export const Locales = {
  // page specific
  baseLayout: {
    virtualEVSEBy: 'Virtual EVSEs by',
  },
  homePage: {
    createVirtualEVSE: 'Create virtual EVSE',
    noRunningEVSEs: 'No running EVSEs',
  },
  loginPage: {
    welcome: 'Welcome',
    loginToContinue: 'To continue, log into EV Energy',
  },
  // common
  actions: {
    goBack: 'Go back',
    logout: 'Logout',
    restart: 'Restart',
    run: 'Run',
    save: 'Save',
    showMore: 'Show More',
    start: 'Start',
    stop: 'Stop',
  },
  labels: {
    basicAuth: 'Basic Auth',
    basicDetails: 'Basic Details',
    chargeRate: 'Charge Rate',
    cpid: 'CPID',
    ctClamp: 'CT Clamp',
    current: 'Current',
    currentlyRunning: 'Currently running',
    custom: 'Custom',
    customHost: 'Custom Host',
    customModel: 'Custom Model',
    customVendor: 'Custom Vendor',
    host: 'Host',
    liveData: 'Live data',
    model: 'Model',
    runningScenario: 'Running scenario',
    scenarios: 'Scenarios',
    status: 'Status',
    vendor: 'Vendor',
    voltage: 'Voltage',
    datadogLogs: 'Logs',
  },
  validation: {
    required: 'Value required',
  },
} as const;
